import { render, staticRenderFns } from "./import-whitelist.vue?vue&type=template&id=6c790c9e&scoped=true&"
import script from "./import-whitelist.vue?vue&type=script&lang=js&"
export * from "./import-whitelist.vue?vue&type=script&lang=js&"
import style0 from "./import-whitelist.vue?vue&type=style&index=0&id=6c790c9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c790c9e",
  null
  
)

export default component.exports